'use client';
import { useMemo } from 'react';
import { useGameSections } from '@/entities/game/model/hooks';
import { GameSection } from '@/widgets/game-section';
import { useI18n } from '@locales/client';
import { useConfirmDataPrompt } from '@/features/data-managment/model/hooks';
import { useUser } from '@/shared/providers/user-provider/use-user';

const RenderCategories = ({
  isGames = false,
  isNotFound = false,
  mobileLandscape,
  openNotAlowedModal,
  setCurrentGame,
}) => {
  const { categoriesWithGames, recommendedGame, preferredGame, newGame } =
    useGameSections();
  const { role } = useConfirmDataPrompt();
  const t = useI18n();
  const { user } = useUser();

  // Фильтрация категорий с учетом авторизации
  const filteredCategories = useMemo(() => {
    return categoriesWithGames?.filter(
      (category) =>
        category.id !== 'bonus' || (category.id === 'bonus' && user?.id)
    );
  }, [categoriesWithGames, user]);

  const renderGameSection = (title = '', games = [], viewCount = true) => (
    <GameSection
      key={games?.at(-1)?.id + title}
      isGames={isGames}
      hasScroll={true}
      mobileLandscape={mobileLandscape}
      rows={games?.length < 4 ? 1 : 2}
      title={title}
      openNotAlowedModal={openNotAlowedModal}
      games={games}
      onGameClick={setCurrentGame}
      viewCount={viewCount}
    />
  );

  // Обработка случая isNotFound
  if (isNotFound) {
    return (
      <>
        {renderGameSection('new', newGame, true)}
        {renderGameSection(t('favorite_games'), preferredGame, false)}
      </>
    );
  }

  const renderPopular = ({ filter = false, recommended = false }) => {
    const isBonus = filteredCategories.find((el) => el.id === 'bonus');
    const isBonusActive = isBonus?.games?.length;

    if (recommended && preferredGame?.length < 2) {
      filter = true;
      recommended = false;
    }

    const renderBonusSection = () => {
      return isBonusActive
        ? renderGameSection(isBonus.id, isBonus.games, true)
        : null;
    };

    const renderRecommendedSections = () => [
      renderBonusSection(),
      renderGameSection(
        t('favorite_games'),
        preferredGame,
        isBonusActive ? false : true
      ),
      renderGameSection(t('recommended_games'), recommendedGame, false),
    ];

    const renderPopularSections = () =>
      filteredCategories
        .filter((category) =>
          filter ? category.id === 'popular' || category.id === 'bonus' : true
        )
        .map((section) => (
          <GameSection
            key={section.id}
            isGames={isGames}
            hasScroll={true}
            mobileLandscape={mobileLandscape}
            rows={section.rows}
            title={section.id}
            openNotAlowedModal={openNotAlowedModal}
            games={section.games}
            onGameClick={setCurrentGame}
            viewCount={section.games.length > 6}
          />
        ));

    return recommended ? renderRecommendedSections() : renderPopularSections();
  };

  const options = useMemo(
    () =>
      isGames
        ? {}
        : role !== 'visitor'
          ? { recommended: true }
          : { filter: true },
    [isGames, role]
  );

  return renderPopular(options);
};

export { RenderCategories };
